import { IIcon } from '@ads/front-ds'

export interface IErrors {
  errors: Errors[]
  footer?: React.ReactElement | string
  boxSize?: ErrorBoxSize
  className?: string
}

export type Errors = {
  variant: Variant
  withSeparator?: boolean
  label?: React.ReactElement | string
  iconName?: IIcon['name']
  items: ErrorItem[]
  itemsInColumn?: number
  onClose?: () => void
}

export type ErrorItem = {
  Icon?: React.ReactElement | IIcon['name']
  Message: React.ReactElement | string
  url?: string
  urlLabel?: string
}

export enum ErrorBoxSize {
  DEFAULT,
  MEDIUM,
  SMALL,
}

export enum Variant {
  WARNING,
  ERROR,
  INFO,
}
